<template>
  <div class="one-photo">
    <div class="photo-wrap">
      <p class="photo-title"><slot name="content"></slot></p>
      <el-upload
              class="uploader"
              action=""
              accept=".jpg,.jpeg,.png,.pdf"
              :show-file-list="false"
              :http-request="uploadImgSuccess"
              :before-upload="beforeImgUpload"

      >
        <img :src="img">
      </el-upload>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TwoPhoto",
    props: {
      img:{
        type: String,
        default: ""
      }
    }
  }
</script>

<style lang="scss" scoped>
  .one-photo {
    .photo-wrap {
      display: inline-block;
      margin: 91px 50px 126px 0;
      .photo-title {
        font-family: Nunito-Regular;
        font-size: 16px;
        color: #2C405A;
        letter-spacing: 0.08px;
        line-height: 24px;
      }
      img {
        width: 256px;
        height: 156px;
        margin-top: 20px;
        border: 1px solid #E5F5FE;
        border-radius: 8px;
      }
    }
  }
</style>